import {
	PersonalInformationDetails,
	MemberAppData,
	Address,
	EducationDetails,
	MembershipProfile,
	CRMMembership,
	OrderGenProduct,
	AppUiData,
	MembershipDetails,

} from "../../shared/models";
import {
	MyAccountDetails,
	Addresses,
	CustomerAddress,
	MedicalSchool,
	Residency,
	Fellowship,
	BoardCertification
} from "../../shared/models/my-account-data.models";
import {
	MembershipStatusReason,
	ACEPMembershipType,
	ACEPMembershipStatus,
	MembershipRate,
	ProductSubType,
	EMRAMembershipType,
	MembershipOrganization
} from "../../shared/enums/xrm.constants";
import {
	ChapterDetails,
	ChapterInfo
} from "../../shared/models/chapter-details";
import {
	SectionDetails,
	SectionInfo
} from "../../shared/models/section-details";
import { MemberType, NotificationStatus } from "../../shared/enums/data.enums";
import { OrderDetails } from "@acepteam/payment";
declare var moment: any;

export function MapMemberAppData(
	myAccountDetails: MyAccountDetails,
	json_load_membership_data: any,
	currentMemberAppdata: MemberAppData = null
): MemberAppData {
	let memberAppData: MemberAppData;
	if (currentMemberAppdata == null) {
		memberAppData = {
			addresses: myAccountDetails.addresses,
			phones: myAccountDetails.primaryContact.phones,
			profile: null,
			orderGenProducts: null,
			AccountProducts: myAccountDetails.AccountProducts,
			ContentSnippets: myAccountDetails.ContentSnippets,

			personalInfo: MapMemberApp_PersonalInformation(myAccountDetails),
			membershipDetails: null,
			educationDetails: MapMemberApp_EducationDetails(myAccountDetails),
			chapterDetails: null,
			sectionDetails: null,
			orderDetails: null,
			medicalLicences: myAccountDetails.credentials.medicallicenses,
			notifyInfo: {
				status: NotificationStatus.None,
				expirationdate: null,
				orderNumber: null,
				orderDetails: new OrderDetails()
			}
		};
	} else {
		memberAppData = currentMemberAppdata;
	}

	memberAppData.profile = MapMemberApp_MembershipProfile(
		myAccountDetails,
		json_load_membership_data
	);
	memberAppData.orderGenProducts = MapOrderGenProducts(
		json_load_membership_data
	);

	return memberAppData;
}

function MapMemberApp_PersonalInformation(
	d: MyAccountDetails
): PersonalInformationDetails {
	let pi = d.primaryContact.personalinfo;

	let personalInformation: PersonalInformationDetails = {
		prefix: pi.prefix,
		firstName: pi.firstname,
		middleName: pi.middlename,
		lastName: pi.lastname,
		suffix: pi.suffix,
		jobTitle: pi.jobtitle,
		npi: d.career.emcareer.npi,
		dateOfBirth: pi.dob,
		gender: pi.gender,
		ethnicity: pi.ethnicity,
		customerAddress: getPrimaryAddress(d.addresses),
		email: d.primaryContact.email,
		phoneType: d.primaryContact.phones.primary,
		phone: d.primaryContact.phones.primaryphone,

		sexualOrientation: pi.sexualOrientation,
		primaryLanguage: pi.primaryLanguage,
		disability: pi.disability,
		pronoun: pi.pronoun,

		//About My Career
		primaryPracticeGeography: pi.primaryPracticeGeography,
		primaryPracticeSetting: pi.primaryPracticeSetting,
		primaryReasonForJoining: pi.primaryReasonForJoining,
	};

	return personalInformation;
}

function MapMemberApp_EducationDetails(d: MyAccountDetails): EducationDetails {
	let ed: EducationDetails = {
		medicalSchool: d.education.medicalschools[0],
		residency: d.education.residencies[0],
		fellowship: d.education.fellowships[0],
		boardCertification: d.credentials.boardcertifications[0]
	};

	return ed;
}

function MapOrderGenProducts(j: any): OrderGenProduct[] {
	let jsondata = j.Table1;
	let ogps: OrderGenProduct[] = jsondata
		.filter(
			c =>
				c.ProductSubType == ProductSubType.ChapterDues ||
				c.ProductSubType == ProductSubType.SECT ||
				c.ProductSubType == ProductSubType.SectionSubscription
		)
		.map(element => {
			return CreateOrderGenProduct(element);
		});

	return ogps;
}

function CreateOrderGenProduct(jsonp: any): OrderGenProduct {
	let m = jsonp;
	let ogp: OrderGenProduct = {
		IsPrimaryChapter: m.IsPrimaryChapter ? m.IsPrimaryChapter : false,
		Selected: m.Selected ? m.Selected : false,
		ProductId: m.ProductId,
		ProductIdname: m.ProductIdname,
		ProductNumber: m.ProductNumber,
		ProductSubType: m.ProductSubType,
		ProductType: m.ProductType,
		UnitPrice: +m.UnitPrice,
		PrimaryEmployer: null,
		StartDate: m.StartDate,
		EndDate: m.EndDate
	};
	return ogp;
}

function MapCRMMembershipRecord(json_mem_data: any): CRMMembership {
	let m = json_mem_data;
	let crmMembership: CRMMembership = {
		MembershipId: m.MembershipId,
		OrderId: m.MembershipOrderId,
		Org: m.OrganizationCode,
		IsOnAutoRenewal: m.IsOnAutoRenewal ? m.IsOnAutoRenewal : false,
		IsOnInstallments: m.OnInstallments ? m.OnInstallments : false,
		MemberStatus: m.MemberStatusCode ? m.MemberStatusCode : ACEPMembershipStatus.None,
		MemberType: m.MemberType ? m.MemberType : ACEPMembershipType.None,
		MemberRate: m.MemberRate ? m.MemberRate : MembershipRate.None,
		FutureMemberRate: m.FutureRate ? m.FutureRate : MembershipRate.None,
		CycleStartDate: m.CycleStartDate, //use order expiration date if available instead of expiration date as we have to adress hte briefspan of time when order is generated but crm update hasnt run yet. MB 6/25/2018
		ExpirationDate: m.OrderExpirationDate
			? m.OrderExpirationDate
			: m.ExpirationDate,
		PaidThroughDate: m.PaidThroughDate,
		JoinDate: m.JoinDate,
		CancellationDate: m.CancellationDate,
		InstallmentOrRenewalDate: m.InstallmentOrRenewalDate,
		ProgressionSuccessFul: m.FutureRate != null
	};



	return crmMembership;
}

function MapMemberApp_MembershipProfile(
	d: MyAccountDetails,
	json_load_membership_data: any
): MembershipProfile {
	let mArr = null;
	if (json_load_membership_data && json_load_membership_data.Table) {
		mArr = json_load_membership_data.Table.map(element => {
			return MapCRMMembershipRecord(element);
		});
	}
	let ed: MembershipProfile = {
		IsInternational: CheckIfInternational(d.addresses),
		IsUSOrCanada: CheckIfUSOrCanada(d.addresses),
		IsRegYR123: false,
		allMemberships: mArr,
		membership: null,
		orders: d.SalesOrders
	};

	//set the acep memebrship record
	//every one coming here will have an acep membership record or will have one
	let acepMems = ed.allMemberships.filter(
		a => a.Org == MembershipOrganization.ACEP
	);

	if (acepMems.length > 1) {
		let _mTemp = acepMems.filter(
			a => a.MemberRate != MembershipRate.None
		)[0];
		ed.membership = _mTemp;
	} else {
		ed.membership = acepMems[0];
	}

	//set if the graduating resident is opting for RegYR123 here..this is inturn calculated through Load membership, which intirn calls progression as the first step
	//MB 3/19/2024
	ed.IsRegYR123 = ed.membership && ed.membership.FutureMemberRate == MembershipRate.RegYR123;

	return ed;
}

export function ArrayContains(parentArr: Array<any>, obj: any) {
	return parentArr.indexOf(obj) > -1;
}

export function getPrimaryAddress(addresses: Addresses): CustomerAddress {
	if (addresses.home.isprimary) return addresses.home;
	if (addresses.hospital.isprimary) return addresses.hospital;
	if (addresses.business.isprimary) return addresses.business;
	if (addresses.home.addressid) {
		return addresses.home;
	}
	return new CustomerAddress();
}

export function CheckIfInternational(addresses: Addresses): boolean {
	const domesticCountries = ["US", "PR"];
	let IsInternational: boolean = !(
		ArrayContains(
			domesticCountries,
			addresses.business.address.country.toUpperCase()
		) &&
		ArrayContains(
			domesticCountries,
			addresses.home.address.country.toUpperCase()
		) &&
		ArrayContains(
			domesticCountries,
			addresses.hospital.address.country.toUpperCase()
		)
	);

	return IsInternational;
}

//pga: coding-5865 check the member is us or canada
export function CheckIfUSOrCanada(addresses: Addresses): boolean {
	const domesticCountries = ["US", "PR", "CA"];
	//Needed to add && conditions because even if some of the address type below are not in use, if the addrees is blank, default country is US
	//Added similar logic in CheckIfInternational function
	let IsUSOrCanada: boolean =
		ArrayContains(
			domesticCountries,
			addresses.business.address.country.toUpperCase()
		) &&
		ArrayContains(
			domesticCountries,
			addresses.home.address.country.toUpperCase()
		) &&
		ArrayContains(
			domesticCountries,
			addresses.hospital.address.country.toUpperCase()
		);

	return IsUSOrCanada;
}




/*MEMBERSHIP TYPE*/
export function MapMembershipDetails(
	myAccountDetails: MyAccountDetails,
	memberAppData: MemberAppData
): MembershipDetails {
	let m: MedicalSchool = memberAppData.educationDetails.medicalSchool;
	let r: Residency = memberAppData.educationDetails.residency;
	let f: Fellowship = memberAppData.educationDetails.fellowship;
	let bc: BoardCertification =
		memberAppData.educationDetails.boardCertification;

	let membertype: MemberType;
	let mems: CRMMembership[] = memberAppData.profile.allMemberships;

	//DETERMINE MEMBER TYPE
	let RATES_STUDENT: MembershipRate[] = [
		MembershipRate.MedStu,
		MembershipRate.CnMedStu,
		MembershipRate.IntMedSt
	];
	let RATES_RESIDENT: MembershipRate[] = [
		MembershipRate.Resident,
		MembershipRate.CnResi,
		MembershipRate.IntResi
	];
	let RATES_FELLOW: MembershipRate[] = [
		MembershipRate.Fellow,
		MembershipRate.CnFellw,
		MembershipRate.IntFellw
	];

	let RATES_MILITARY: MembershipRate[] = [
		MembershipRate.Mil1YR,
		MembershipRate.MilYR1,
		MembershipRate.MilYR2,
		MembershipRate.GMOYR1,
		MembershipRate.GMOYR1,
		MembershipRate.GMOYR2,
		MembershipRate.GMOYR3,
		MembershipRate.GMOYR4,
		MembershipRate.InGMO
	];

	let MEMBERTYPES_PHYSICIAN: any = [
		ACEPMembershipType.Regular,
		ACEPMembershipType.International
	];

	//pga: coding-4909 Rates for retire 
	let RATES_RETIRE: MembershipRate[] = [
		MembershipRate.RegRet,
		MembershipRate.CnRet
	];

	//pga: coding-4909 Retired
	//Need to add the retired condition before physician, becasue the retired rate members are also ACEP Regular/ACEP International
	//RETIRED
	if (
		mems.filter(a => ArrayContains(RATES_RETIRE, a.MemberRate)).length > 0
	) {
		membertype = MemberType.Retired;
	}
	//PHYSICIAN
	else if (
		mems.filter(a => ArrayContains(MEMBERTYPES_PHYSICIAN, a.MemberType))
			.length > 0
	) {
		membertype = MemberType.Physician;
	}
	//STUDENT
	else if (
		mems.filter(a => ArrayContains(RATES_STUDENT, a.MemberRate)).length > 0
	) {
		membertype = MemberType.Student;
	}

	//RESIDENT
	else if (
		mems.filter(a => ArrayContains(RATES_RESIDENT, a.MemberRate)).length > 0
	) {
		membertype = MemberType.Resident;
	}

	//FELLOW
	else if (
		mems.filter(a => ArrayContains(RATES_FELLOW, a.MemberRate)).length > 0
	) {
		membertype = MemberType.Fellow;
	}



	// If no rate was available..fall back to set member type from educaiton available
	if (!membertype) {
		if (m && new Date(m.graduationdate) > new Date()) {
			membertype = MemberType.Student;
		} else if (r && new Date(r.graduationdate) > new Date()) {
			membertype = MemberType.Resident;
		} else if (f && new Date(f.graduationdate) > new Date()) {
			membertype = MemberType.Fellow;
		}
	}

	//pga: changed a.MemberType -> a.MemberRate as it was checkking Type in rate array 
	//MILITARY
	let activeMilitary: any =
		mems && mems.length > 0
			? mems.filter(a => ArrayContains(RATES_MILITARY, a.MemberRate))
				.length > 0
			: null;

	let membershipDetails: MembershipDetails = {
		activeMilitary: activeMilitary || Boolean(myAccountDetails.career.military.activeMilitary),
		emResidencyTrained: null,
		memberType: membertype,
		startEMBefore2000: null,
		military: myAccountDetails.career.military
	};

	return membershipDetails;
}

/* CHAPTERS */
export function removeDuplicates(myArr, prop) {
	return myArr.filter((obj, pos, arr) => {
		return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
	});
}

export function MapChapterDetails(
	memberAppData: MemberAppData
): ChapterDetails {
	let chapterDetails: ChapterDetails; // = memberAppData.chapterDetails;

	let chapterInfos: ChapterInfo[] = [];

	let home_State: string = memberAppData.addresses.home.address.state;
	let hospital_State: string = memberAppData.addresses.hospital.address.state;
	let business_State: string = memberAppData.addresses.business.address.state;
	let license_State: string = null;

	if (memberAppData.medicalLicences.length > 0) {
		license_State = memberAppData.medicalLicences[0].licensestateprovince;
	}

	//Home Address
	let ci: ChapterInfo;
	ci = getChapterInfo_From_AccountProducts(
		home_State,
		memberAppData.AccountProducts
	);
	if (ci) {
		chapterInfos.push(ci);
	}

	//Hospital Adress
	ci = getChapterInfo_From_AccountProducts(
		hospital_State,
		memberAppData.AccountProducts
	);
	if (ci) {
		chapterInfos.push(ci);
	}

	//Business Adress
	ci = getChapterInfo_From_AccountProducts(
		business_State,
		memberAppData.AccountProducts
	);
	if (ci) {
		chapterInfos.push(ci);
	}

	//GS
	ci = getChapterInfo_From_AccountProducts(
		"GS",
		memberAppData.AccountProducts
	);
	if (ci) {
		chapterInfos.push(ci);
	}

	//Medical License Adress
	ci = getChapterInfo_From_AccountProducts(
		license_State,
		memberAppData.AccountProducts
	);
	if (ci) {
		chapterInfos.push(ci);
	}


	//distinct
	chapterInfos = Array.from(new Set(chapterInfos));
	chapterInfos = removeDuplicates(chapterInfos, "code");

	chapterDetails = {
		chapters: chapterInfos
	};

	chapterDetails = processChapterDetails(chapterDetails, memberAppData);

	return chapterDetails;
}

//Sets Primary and Selected fields
function processChapterDetails(
	chapterDetails: ChapterDetails,
	memberAppData: MemberAppData
): ChapterDetails {
	//If only 1 chapter..just set selected and isprimary to true
	//exclude GS MB 3/24/2022 ACEPMEMBER-818
	if (chapterDetails.chapters.length == 1) {
		if (chapterDetails.chapters[0].code != 'GS') {
			chapterDetails.chapters[0].selected = true;
			chapterDetails.chapters[0].isPrimary = true;
		}
		return chapterDetails;
	}

	let selectedChaps = memberAppData.orderGenProducts.filter(
		c => c.ProductSubType == ProductSubType.ChapterDues
	);
	for (let index = 0; index < chapterDetails.chapters.length; index++) {
		let ogps: OrderGenProduct[] = selectedChaps.filter(
			s =>
				s.ProductNumber.toUpperCase() ==
				chapterDetails.chapters[index].code.toUpperCase()
		);
		if (ogps.length > 0) {
			let ogp: OrderGenProduct = ogps[0];
			chapterDetails.chapters[index].selected = true;
			chapterDetails.chapters[index].isPrimary = ogp.IsPrimaryChapter;
		}
	}

	//if no primary set in the database..
	if (chapterDetails.chapters.filter(s => s.isPrimary).length == 0) {
		//check if military..ilitary shud have GS by default
		if (
			memberAppData.membershipDetails &&
			memberAppData.membershipDetails.activeMilitary
		) {
			chapterDetails.chapters.find(a => a.code == "GS").selected = true;
			chapterDetails.chapters.find(a => a.code == "GS").isPrimary = true;
		} else {
			//set from primary address
			let primaryAddress: CustomerAddress = getPrimaryAddress(
				memberAppData.addresses
			);
			if (
				chapterDetails.chapters.find(
					a => a.code == primaryAddress.address.state
				) != null
			) {
				chapterDetails.chapters.find(
					a => a.code == primaryAddress.address.state
				).selected = true;
				chapterDetails.chapters.find(
					a => a.code == primaryAddress.address.state
				).isPrimary = true;
			}
		}
	}

	//select previously selected chapters from UI if coming back and fro
	if (memberAppData.chapterDetails && chapterDetails.chapters) {
		chapterDetails.chapters.forEach(
			a =>
			(a.selected =
				memberAppData.chapterDetails.chapters.filter(
					c => c.code == a.code && c.selected
				).length > 0)
		);
	}

	return chapterDetails;
}

export function getChapterInfo_From_AccountProducts(
	state: string,
	AccountProducts: any
): ChapterInfo | any {
	if (!state) {
		return null;
	}

	let chap = AccountProducts.filter(
		c =>
			c.productsubtype == "Chapter Dues" &&
			c.accountcode.toUpperCase() == state.toUpperCase()
	)[0];

	let ci: ChapterInfo = chap
		? {
			code: chap.accountcode,
			id: chap.accountid,
			isPrimary: false,
			name: chap.name,
			selected: false
		}
		: null;

	return ci;
}

/* SECTIONS */
export function MapSectionDetails(
	memberAppData: MemberAppData
): SectionDetails {
	let isSectionApp = window.location.href.indexOf('sectionapp') > -1;


	let isCurrentAcepMember_SectionApp = false;
	if (!!memberAppData) {
		isCurrentAcepMember_SectionApp = (moment(memberAppData.profile.membership?.PaidThroughDate) > moment()) && !!memberAppData.profile.membership?.JoinDate;
	}


	let PRODUCT_SUBTYPE = isSectionApp && !isCurrentAcepMember_SectionApp ? "Section Subscription" : "SECT";
	let sectionDetails: SectionDetails; // = memberAppData.chapterDetails;

	let sectionInfos: SectionInfo[] = memberAppData.AccountProducts.filter(
		c => c.productsubtype == PRODUCT_SUBTYPE
	).map(s => {
		return CreateSectionInfo(s);
	});

	// Load resources from a test folder for non-prod environments since sections images are not yet available in non-prod S3 bucket. MB 4/20/2026 	
	let isTest = window.location.href.indexOf('//webapps') == -1;

	if (isTest) {
		//In test environment, replace the /sections/ with /sections-test/ in the img url 
		sectionInfos.forEach(s => {
			s.img = s.img.replace('/sections/', '/sectionstest/');
		});
	}


	sectionDetails = {
		sections: sectionInfos
	};

	sectionDetails = processSectionDetails(sectionDetails, memberAppData);
	return sectionDetails;
}

function CreateSectionInfo(jsonp: any): SectionInfo {
	let m = jsonp;

	let si: SectionInfo = {
		name: m.name,
		id: m.accountid,
		url: m.url,
		code: m.accountcode,
		productnumber: m.productnumber,
		description: m.description || `No description found`,
		img: `https://s3.amazonaws.com/acep-assets/sections/${m.accountcode.toLowerCase()}.png`,
		selected: false,
		enabled: true, //used for section applciation
		isFree: false //No Price ..eg: YPS for Candidates
	};

	return si;
}

function processSectionDetails(
	sectionDetails: SectionDetails,
	memberAppData: MemberAppData
): SectionDetails {

	let isCurrentAcepMember = false;

	if (!!memberAppData) {
		isCurrentAcepMember = (moment(memberAppData.profile.membership?.PaidThroughDate) > moment()) && !!memberAppData.profile.membership?.JoinDate;
	}


	let _selectedSectns = memberAppData.orderGenProducts.filter(
		c => c.ProductSubType == ProductSubType.SECT || c.ProductSubType == ProductSubType.SectionSubscription
	);


	let isSectionApplication = window.location.href.indexOf('sectionapp') > -1;

	let selectedSectns: OrderGenProduct[] = [];
	//selectedSectns:
	//There could be 2 section records here where one of the records could have a null start/end date and the other 
	//might have valid data in it. i nthis case..remove the null start/end date record
	//MB 1/28/2025

	_selectedSectns.forEach(s => {
		let sectionFound = selectedSectns.find(a => a.ProductId == s.ProductId);
		if (!!!sectionFound) {
			//section not found
			selectedSectns.push(s);
		}
		else {
			//section found
			//check if start date is NOT null..then overwrite the null date fields with valid date fields
			if (!!(s.StartDate)) sectionFound.StartDate = s.StartDate;
			if (!!(s.EndDate)) sectionFound.EndDate = s.EndDate;
		}
	})

	for (let index = 0; index < sectionDetails.sections.length; index++) {
		let ogps: OrderGenProduct[] = selectedSectns.filter(
			s => s.ProductNumber == sectionDetails.sections[index].productnumber
		);
		if (ogps.length > 0) {
			let ogp: OrderGenProduct = ogps[0];

			sectionDetails.sections[index].selected = true;

			if (+ogp.UnitPrice == 0) {
				sectionDetails.sections[index].isFree = true;
			}

			//SectionApp - //LET THEM RENEW 1 MONTH BEFORE EXPIRY//
			let _enabled_SectionApp = true;
			let endDate: any = ogp.EndDate;
			let numberOfDaysBeforeExpiry = -(moment().diff(endDate, 'days'));
			if (!!numberOfDaysBeforeExpiry) {
				_enabled_SectionApp = numberOfDaysBeforeExpiry < 30;
			}
			sectionDetails.sections[index].enabled = (isSectionApplication ? (isCurrentAcepMember ? !!!ogp.EndDate : _enabled_SectionApp) : true);

		}
	}

	return sectionDetails;
}


